import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import MenuButton from "../MenuButton/MenuButton";
import UserServices from "../../UserServices/UserServices";
import Pagination from "react-js-pagination";
import useSortableData from "../../hooks/useSortableData";
import useTable from "../../hooks/useTable";
import { NoteState } from "../../context/notes/NoteState";
import moment from "moment";
import jsPDF from "jspdf";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import DashboardBranchFilter, {
  useDashboardBranch,
} from "../Includes/DashboardBranchFilter";
import "../AdminDashboard/AdminDashboard.css";
import "./salesDashboard.css";

const RENEWAL_TABS = {
  gym: "1",
  trainer: "2",
  gx: "15",
};

const PIE_COLORS = ["#0f766e", "#e8002b", "#64748b", "#d97706"];

const money = (value) =>
  `Rs ${Number(value || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 })}`;

const Kpi = ({ label, value, sub, icon, to }) => {
  const card = (
    <div className="ad-kpi ad-tone-slate">
      <div className="ad-kpi-body">
        <p className="ad-kpi-label">{label}</p>
        <h4 className="ad-kpi-value">{value}</h4>
        {sub ? <p className="ad-kpi-sub">{sub}</p> : null}
      </div>
      <div className="ad-kpi-icon">
        <i className={`bi ${icon}`}></i>
      </div>
    </div>
  );
  if (!to) return card;
  return (
    <Link to={to} className="sd-kpi-link">
      {card}
    </Link>
  );
};

const Dashboard = () => {
  const [f11ClientCount, setF11ClientCount] = useState("");
  const [g13ClientCount, setG13ClientCount] = useState("");
  const [totalAllClientsCount, setTotalAllClientsCount] = useState("");
  const [Catagry, setCatagry] = useState(RENEWAL_TABS.gym);
  const [inactiveclientCount, setinavtiveClientCount] = useState("");
  const [activeclientCount, setavtiveClientCount] = useState("");
  const [dormantclientCount, setdormantClientCount] = useState("");
  const [sellpackageCount, setSellPackageCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [myData, setMyData] = useState([]);
  const [limit, setLimit] = useState("25");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const [duration, setDuration] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [renewalStatusFilter, setRenewalStatusFilter] = useState("all");
  const [renewalSummary, setRenewalSummary] = useState({
    total: 0,
    renewed: 0,
    expired: 0,
    pending: 0,
    remaining: 0,
  });
  const [monthSales, setMonthSales] = useState(0);
  const [packageSales, setPackageSales] = useState([]);
  const [snapshot, setSnapshot] = useState(null);
  const { state } = useContext(NoteState);
  const { branch_id, role } = state;
  const { branch, setBranch, apiBranch } = useDashboardBranch(role, branch_id);
  var CurrencyFormat = require("react-currency-format");

  const emptySummary = {
    total: 0,
    renewed: 0,
    expired: 0,
    pending: 0,
    remaining: 0,
  };

  const buildRenewalFilters = (overrides = {}) => ({
    duration: overrides.duration !== undefined ? overrides.duration : duration,
    from_date: overrides.from_date !== undefined ? overrides.from_date : fromDate,
    to_date: overrides.to_date !== undefined ? overrides.to_date : toDate,
    renewal_status:
      overrides.renewal_status !== undefined
        ? overrides.renewal_status
        : renewalStatusFilter,
  });

  const clientCounter = async () => {
    try {
      const totalRes = await UserServices.clientCount("");
      if (totalRes.status === 200) {
        setTotalAllClientsCount(totalRes.data.all_clients);
        setavtiveClientCount(totalRes.data.active_clients);
        setinavtiveClientCount(totalRes.data.inactive_clients);
        setdormantClientCount(totalRes.data.dormant_clients);
      }
    } catch (err) {
      setTotalAllClientsCount("0");
      setavtiveClientCount("0");
      setinavtiveClientCount("0");
      setdormantClientCount("0");
    }

    try {
      const f11Res = await UserServices.clientCount("15");
      if (f11Res.status === 200) {
        setF11ClientCount(f11Res.data.active_clients ?? f11Res.data.qualifying_active_clients);
      }
    } catch (err) {
      setF11ClientCount("0");
    }

    try {
      const g13Res = await UserServices.clientCount("1");
      if (g13Res.status === 200) {
        setG13ClientCount(g13Res.data.active_clients ?? g13Res.data.qualifying_active_clients);
      }
    } catch (err) {
      setG13ClientCount("0");
    }
  };
  const loadInsights = async () => {
    try {
      const snap = await UserServices.salesDashboardSnapshot(apiBranch);
      const payload = snap.status === 200 ? snap.data?.data : null;
      setSnapshot(payload);

      const todayNet = Number(payload?.sales_today?.net ?? 0);
      setSellPackageCount(todayNet > 0 ? todayNet.toLocaleString("en-PK") : "0");
      setMonthSales(Number(payload?.sales_mtd?.net ?? 0));
      setPackageSales(
        (payload?.package_sales_mtd || []).map((row) => ({
          name: row.name,
          net: Number(row.net || 0),
        }))
      );
    } catch (err) {
      setSnapshot(null);
      setSellPackageCount("0");
      setMonthSales(0);
      setPackageSales([]);
    }
  };

  const mapRenewalRows = (rows) =>
    (rows || []).map((value) => ({
      client_id: value.client_id,
      name: value.name,
      package_name: value.package_name,
      price: value.price,
      end_date: value.end_date,
      orderStatus: value.orderStatus,
      renewal_status: value.renewal_status || "pending",
    }));

  const getUsers = async (page, pageLimit, category, filterOverrides = {}) => {
    setLoading(true);
    const pageNo = page;
    const newLimit = pageLimit;
    setLimit(newLimit);
    const filters = buildRenewalFilters(filterOverrides);
    try {
      const responce = await UserServices.getGymPackages(
        apiBranch || "",
        category,
        newLimit,
        pageNo,
        filters
      );

      if (responce.status === 200) {
        setMyData(mapRenewalRows(responce.data.data.data));
        setLimit(responce.data.data.per_page);
        setTotalResults(responce.data.totalRecord);
        setTotalPages(responce.data.totalPages);
        setCurrentPage(responce.data.data.current_page);
        setRenewalSummary(responce.data.summary || emptySummary);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 404) {
        setTotalResults("0");
        setTotalPages("1");
        setMyData([]);
        setRenewalSummary(
          (err.response.data && err.response.data.summary) || emptySummary
        );
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    clientCounter();
  }, []);

  useEffect(() => {
    getUsers(1, limit, Catagry);
    loadInsights();
  }, [apiBranch]);
  const applyDatePreset = (packageTime) => {
    setDuration(packageTime);
    // Preset clears custom dates so backend uses duration logic.
    setFromDate("");
    setToDate("");
    getUsers(1, limit, Catagry, {
      duration: packageTime,
      from_date: "",
      to_date: "",
    });
  };

  const applyCustomDateFilter = () => {
    if (!fromDate || !toDate) {
      window.alert("Please select both From and To dates.");
      return;
    }
    if (moment(fromDate).isAfter(moment(toDate))) {
      window.alert("From date cannot be after To date.");
      return;
    }
    setDuration("");
    if (document.getElementById("filtered")) {
      document.getElementById("filtered").selectedIndex = 0;
    }
    getUsers(1, limit, Catagry, {
      duration: "",
      from_date: fromDate,
      to_date: toDate,
    });
  };

  const applyRenewalStatusFilter = (statusValue) => {
    setRenewalStatusFilter(statusValue);
    getUsers(1, limit, Catagry, { renewal_status: statusValue });
  };

  const resetCategoryFilters = () => {
    setDuration("");
    setFromDate("");
    setToDate("");
    setRenewalStatusFilter("all");
    setRenewalSummary(emptySummary);
    if (document.getElementById("filtered")) {
      document.getElementById("filtered").selectedIndex = 0;
    }
  };

  const renewalStatusLabel = (status) => {
    if (status === "renewed") return "Renewed";
    if (status === "expired") return "Expired";
    return "Pending";
  };

  const renewalStatusBadgeClass = (status) => {
    if (status === "renewed") return "sd-status sd-status-renewed";
    if (status === "expired") return "sd-status sd-status-expired";
    return "sd-status sd-status-pending";
  };
  const generatePdf = (table) => {
    const doc = new jsPDF("p", "mm", "letter");

    // Loop through all the tables in the section and add them to the PDF

    // Add a new page for each table (skip first table as it is already on the first page)
    const captionText = table.getAttribute("data-caption");
    // Add the table caption as regular text above the table
    doc.text(captionText, 10, 10);
    const tableOptions = {
      headStyles: { fillColor: [232, 0, 43], textColor: 255 },
      styles: { fontSize: 5 }, // Adjust the font size here to fit the table content
    };
    doc.autoTable({
      html: table,
      ...tableOptions,
    });

    doc.save("section_tables.pdf");
  };
  const Table = ({ data, rowsPerPage }) => {
    const { slice } = useTable(data, 1, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <>
        <table
          className="table table-striped table-borderless sd-renew-table"
          id="report-POS"
          data-caption={
            Catagry === RENEWAL_TABS.gym
              ? "RENEWALS GYM PACKAGES"
              : Catagry === RENEWAL_TABS.trainer
                ? "RENEWALS TRAINER PACKAGES"
                : Catagry === RENEWAL_TABS.gx
                  ? "RENEWALS GX / CLASSES"
                  : null
          }
        >
          <thead>
            <tr>
              <th scope="col" className="no_sort">
                Sr#
              </th>
              <th
                scope="col"
                onClick={() => requestSort("name")}
                className={getClassNamesFor("name")}
              >
                Client
              </th>
              <th
                scope="col"
                onClick={() => requestSort("package_name")}
                className={getClassNamesFor("package_name")}
              >
                Package Name
              </th>
              <th
                scope="col"
                onClick={() => requestSort("price")}
                className={getClassNamesFor("price")}
              >
                Package Price
              </th>
              <th
                scope="col"
                onClick={() => requestSort("end_date")}
                className={getClassNamesFor("end_date")}
              >
                Renewal Date
              </th>
              <th
                scope="col"
                onClick={() => requestSort("renewal_status")}
                className={getClassNamesFor("renewal_status")}
              >
                Renewal Status
              </th>
              <th scope="col" className="no_sort">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {items.length ? (
              items.map((el, index) => (
                <tr key={index}>
                  <td>
                    {currentPage === 1
                      ? index + 1
                      : (currentPage - 1) * limit + index + 1}
                  </td>
                  <td>
                    {" "}
                    <Link to={"/client-home/" + el.client_id}>{el.name}</Link>
                  </td>
                  <td>{el.package_name}</td>
                  <td>
                    <CurrencyFormat
                      value={el.price}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"Rs "}
                      suffix={"/-"}
                      thousandSpacing={"2s"}
                    />
                  </td>
                  <td>{moment(el.end_date).format("DD-MM-YYYY")}</td>
                  <td>
                    <span className={`renew-pkg ${renewalStatusBadgeClass(el.renewal_status)}`}>
                      {renewalStatusLabel(el.renewal_status)}
                    </span>
                  </td>
                  <td>
                    {el.renewal_status === "renewed" || el.orderStatus === "1" ? (
                      <button className="renew-pkg custom-active-button">
                        <i className="bi bi-check2-circle"></i>{" "}
                        {el.renewal_status === "renewed" ? "Done" : "Active"}
                      </button>
                    ) : (
                      <Link
                        to={"/package-sell/" + el.client_id + "?saleType=Renew"}
                        className="renew-pkg custom-block-button"
                      >
                        <i className="bi bi-plus-circle"></i> Renew
                      </Link>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="14" className="text-center text-capitalize">
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {totalResults > limit && totalPages > 1 ? (
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={parseInt(limit)}
            totalItemsCount={totalResults}
            onChange={(e) => {
              getUsers(e, limit, Catagry);
            }}
            pageRangeDisplayed={8}
            itemClass="page-item"
            linkClass="page-link"
            firstPageText="First Page"
            lastPageText="Last Page"
          />
        ) : (
          ""
        )}
      </>
    );
  };

  const canClients = role === "3" || role === "1" || role === "4" || role === "12";
  const canSales = role === "3" || role === "1" || role === "4" || role === "5" || role === "12";
  const renewalTitle =
    Catagry === RENEWAL_TABS.gym
      ? "Gym package renewals"
      : Catagry === RENEWAL_TABS.trainer
        ? "Trainer package renewals"
        : "GX / class renewals";
  const renewalChart = [
    { name: "Renewed", value: Number(renewalSummary.renewed || 0) },
    { name: "Expired", value: Number(renewalSummary.expired || 0) },
    { name: "Remaining", value: Number(renewalSummary.remaining || 0) },
  ].filter((row) => row.value > 0);
  const footfall = snapshot?.footfall || {};
  const footfallChart = [
    { name: "Morning", value: Number(footfall.morning || 0) },
    { name: "Afternoon", value: Number(footfall.afternoon || 0) },
    { name: "Evening", value: Number(footfall.evening || 0) },
  ];
  const packageChart = packageSales || [];

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design ad-shell sd-shell">
          <MenuButton />
          <div className="container-fluid py-3">
            <div className="ad-topbar">
              <div>
                <p className="ad-eyebrow">Sales</p>
                <h1 className="ad-title">Sales dashboard</h1>
                <p className="ad-subtitle">
                  Clients, sales, renewals, attendance and birthdays. Existing counts and the renewal list use the same rules as before.
                </p>
              </div>
              <div className="ad-toolbar">
                <DashboardBranchFilter
                  role={role}
                  loginBranchId={branch_id}
                  value={branch}
                  onChange={setBranch}
                />
              </div>
            </div>

            {canClients || canSales ? (
              <div className="ad-kpi-grid">
                {canClients ? (
                  <Kpi label="Total clients" value={totalAllClientsCount || "0"} sub="All branches" icon="bi-people" to="/view-clients" />
                ) : null}
                {canClients ? (
                  <Kpi label="F-11 active clients" value={f11ClientCount || "0"} icon="bi-geo-alt" to="/view-clients" />
                ) : null}
                {canClients ? (
                  <Kpi label="G-13 active clients" value={g13ClientCount || "0"} icon="bi-geo-alt" to="/view-clients" />
                ) : null}
                {canClients ? (
                  <Kpi
                    label="Active clients"
                    value={activeclientCount || "0"}
                    icon="bi-person-check"
                    to="/view-clients"
                  />
                ) : null}
                {canClients ? (
                  <Kpi label="Inactive clients" value={inactiveclientCount || "0"} icon="bi-person-dash" to="/view-clients" />
                ) : null}
                {canClients ? (
                  <Kpi label="Dormant clients" value={dormantclientCount || "0"} icon="bi-person-lock" to="/view-clients" />
                ) : null}
                {canSales ? (
                  <Kpi label="Today sales" value={sellpackageCount ? `Rs ${sellpackageCount}` : "Rs 0"} sub="Collected today" icon="bi-cash-stack" to="/manage-sales" />
                ) : null}
                {canSales ? (
                  <Kpi label="Month sales" value={money(monthSales)} sub={moment().format("MMMM YYYY")} icon="bi-calendar3" to="/manage-sales" />
                ) : null}
              </div>
            ) : null}

            {role === "4" ? (
              <div className="mb-3">
                <Link to="/search-client" className="btn btn-danger">
                  <i className="bi bi-ui-checks me-1"></i> Sell package
                </Link>
              </div>
            ) : null}

            <div className="row g-3 mb-3">
              <div className="col-12 col-xl-7">
                <div className="ad-panel">
                  <div className="ad-panel-head">
                    <h5>Package-wise sales this month</h5>
                    <span className="ad-chip">Detailed Sales Report</span>
                  </div>
                  {packageChart.length ? (
                    <div className="ad-chart">
                      <ResponsiveContainer width="100%" height={260}>
                        <BarChart data={packageChart}>
                          <CartesianGrid strokeDasharray="3 3" vertical={false} />
                          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                          <YAxis tick={{ fontSize: 12 }} />
                          <Tooltip formatter={(value) => money(value)} />
                          <Bar dataKey="net" fill="#e8002b" radius={[6, 6, 0, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  ) : (
                    <p className="text-muted mb-0">No package sales loaded for this month yet.</p>
                  )}
                </div>
              </div>
              <div className="col-12 col-xl-5">
                <div className="ad-panel">
                  <div className="ad-panel-head">
                    <h5>Client attendance today</h5>
                    <span className="ad-chip">{Number(footfall.total || 0).toLocaleString("en-PK")} check-ins</span>
                  </div>
                  <div className="ad-metrics">
                    <div className="ad-metric"><span className="ad-metric-label">Female</span><strong className="ad-metric-value">{footfall.female || 0}</strong></div>
                    <div className="ad-metric"><span className="ad-metric-label">Male</span><strong className="ad-metric-value">{footfall.male || 0}</strong></div>
                    <div className="ad-metric"><span className="ad-metric-label">Gym packages due in 7 days</span><strong className="ad-metric-value">{snapshot?.expiring_7_days || 0}</strong></div>
                  </div>
                  <div className="ad-chart" style={{ minHeight: 160 }}>
                    <ResponsiveContainer width="100%" height={160}>
                      <PieChart>
                        <Pie data={footfallChart} dataKey="value" nameKey="name" innerRadius={42} outerRadius={68}>
                          {footfallChart.map((entry, index) => (
                            <Cell key={entry.name} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-3 mb-4">
              <div className="col-12 col-xl-7">
                <div className="ad-panel">
                  <div className="ad-panel-head">
                    <h5>Trainer-wise sales this month</h5>
                    <span className="ad-chip">PT and Small PT</span>
                  </div>
                  <div className="ad-table-wrap">
                    <table className="ad-table">
                      <thead>
                        <tr>
                          <th>Trainer</th>
                          <th>Clients</th>
                          <th>Sales</th>
                          <th>Package value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(snapshot?.trainers || []).length ? (
                          snapshot.trainers.map((row) => (
                            <tr key={row.name}>
                              <td>{row.name}</td>
                              <td>{row.clients}</td>
                              <td>{row.sales}</td>
                              <td>{money(row.amount)}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="4">No trainer sales this month.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-12 col-xl-5">
                <div className="ad-panel">
                  <div className="ad-panel-head">
                    <h5>Client birthdays</h5>
                    <span className="ad-chip">Rest of this month</span>
                  </div>
                  <div className="ad-table-wrap">
                    <table className="ad-table">
                      <thead>
                        <tr>
                          <th>Client</th>
                          <th>Date</th>
                          <th>Branch</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(snapshot?.birthdays || []).length ? (
                          snapshot.birthdays.map((row) => (
                            <tr key={row.id}>
                              <td>
                                <Link to={"/client-home/" + row.id}>{row.name}</Link>
                                {row.is_today ? <span className="sd-status sd-status-renewed ms-2">Today</span> : null}
                              </td>
                              <td>{row.day}{row.turns ? ` · turns ${row.turns}` : ""}</td>
                              <td>{row.branch}</td>
                            </tr>
                          ))
                        ) : (
                          <tr><td colSpan="3">No upcoming birthdays this month.</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {role !== "12" ? (
              <div className="ad-panel">
                <div className="ad-panel-head">
                  <h5>{renewalTitle}</h5>
                  <span className="ad-chip">{renewalSummary.total || 0} due</span>
                </div>
                <div className="sd-tabs">
                  {[
                    [RENEWAL_TABS.gym, "Gym packages"],
                    [RENEWAL_TABS.trainer, "Trainer packages"],
                    [RENEWAL_TABS.gx, "GX"],
                  ].map(([id, label]) => (
                    <button
                      key={id}
                      type="button"
                      className={`sd-tab ${Catagry === id ? "is-on" : ""}`}
                      onClick={() => {
                        if (Catagry === id) return;
                        resetCategoryFilters();
                        setCatagry(id);
                        getUsers("1", "25", id, {
                          duration: "",
                          from_date: "",
                          to_date: "",
                          renewal_status: "all",
                        });
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <div className="row g-3 mb-3">
                  <div className="col-6 col-md-3"><Kpi label="Total due" value={renewalSummary.total || 0} icon="bi-list-check" /></div>
                  <div className="col-6 col-md-3"><Kpi label="Renewed" value={renewalSummary.renewed || 0} icon="bi-check2-circle" /></div>
                  <div className="col-6 col-md-3"><Kpi label="Expired" value={renewalSummary.expired || 0} icon="bi-x-circle" /></div>
                  <div className="col-6 col-md-3"><Kpi label="Remaining" value={renewalSummary.remaining || 0} icon="bi-hourglass-split" /></div>
                </div>
                <div className="row g-3">
                  <div className="col-12 col-lg-8">
                    <div className="sd-filters">
                      <div>
                        <label className="form-label mb-1 small">From</label>
                        <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                      </div>
                      <div>
                        <label className="form-label mb-1 small">To</label>
                        <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                      </div>
                      <button type="button" className="btn btn-danger" onClick={applyCustomDateFilter}>Apply date</button>
                      <select id="filtered" className="form-select" defaultValue="" onChange={(e) => applyDatePreset(e.target.value)}>
                        <option value="" disabled>Quick filter</option>
                        <option value="AllYear">All (expired in last year)</option>
                        <option value="Today">Due today</option>
                        <option value="Yesterday">Due yesterday</option>
                        <option value="Coming5Days">Due in 5 days</option>
                        <option value="Coming7Days">Due in 7 days</option>
                        <option value="Previous5Days">Due in last 5 days</option>
                      </select>
                      <select className="form-select" value={limit} onChange={(e) => getUsers("1", e.target.value, Catagry)}>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="250">250</option>
                        <option value="500">500</option>
                      </select>
                      <select className="form-select" value={renewalStatusFilter} onChange={(e) => applyRenewalStatusFilter(e.target.value)}>
                        <option value="all">All status</option>
                        <option value="renewed">Renewed</option>
                        <option value="expired">Expired</option>
                        <option value="pending">Pending</option>
                      </select>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => generatePdf(document.getElementById("report-POS"))}
                      >
                        <i className="bi bi-file-earmark-pdf"></i> PDF
                      </button>
                    </div>
                    <div className="table-responsive">
                      <Table data={myData} rowsPerPage={limit} />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4">
                    <div className="ad-chart">
                      {renewalChart.length ? (
                        <ResponsiveContainer width="100%" height={240}>
                          <PieChart>
                            <Pie data={renewalChart} dataKey="value" nameKey="name" innerRadius={52} outerRadius={80}>
                              {renewalChart.map((entry, index) => (
                                <Cell key={entry.name} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                              ))}
                            </Pie>
                            <Tooltip />
                          </PieChart>
                        </ResponsiveContainer>
                      ) : (
                        <p className="text-muted">No renewal split for this filter.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </main>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
};

export default Dashboard;
